<template>
  <v-btn class="dppl-button" elevation="0" v-bind="{ ...$props, ...$attrs }">
    <slot />
  </v-btn>
</template>

<style lang="less" scoped>
.dppl-button.v-btn {
  padding: 12px;
  border-radius: 8px;
  text-transform: none;
  line-height: 18px;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.v-btn--variant-outlined {
    border: 1px solid @stroke-default;
  }
}
</style>
